import { AssessmentInstanceDto, AssessmentInstanceResultDto, AssessmentMode } from "generated/CoreApi_v1";
import React from "react";
import { AssPlayerConclusionBox } from "views/assessment/player/Conclusion/AssPlayerConclusionBox";
import { ChallengeConclusion } from "views/assessment/player/Conclusion/ChallengeConclusion";

/////////////////////////////////////////////////////////////////////////////////

interface IProps {
    viewData: AssessmentInstanceDto;
    result: AssessmentInstanceResultDto;
    fullScreenMode: boolean;
}

export const AssPlayerConclusion: React.FC<IProps> = (props) => {

    const { viewData, result, fullScreenMode } = props;

    return (
        <>
            {
                viewData.mode == AssessmentMode.Challenge
                    ?
                    <ChallengeConclusion />
                    :
                    <AssPlayerConclusionBox viewData={viewData} resultData={result} fullScreenMode={fullScreenMode} />
            }
        </>
    );
};
